/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchManager = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchManager.prototype = {
    /* The view object name */
    name: '',
    /* The view object instance */
    view: {
        manage: [
            {
                name: 'match',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'getUnionMatchHome',
                query: {
                    id: 'id'
                },
                basePath: 'data',
                rule: {
                    id: 'id',
                    organizationId: 'accountId',
                    name: 'chineseName',
                    logoUrl: 'icon',
                    status: '$state',
                    publishStatus: '$status',
                    matchGroupId: 'matches.0.id',
                    isSignupOn: 'accountOnlineSignupOpen',
                    authStatus: '$accountCertificationStatus',
                }
            },
            {
                name: 'role',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetMatchMyManagerRole',
                query: {
                    unionMatchId: 'id'
                },
                basePath: 'data',
                rule: {
                    isManager: '@isManager',
                    isReferee: '@isReferee',
                }
            },
        ],
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateBMUnionMatch',
            basePath: '',
            rule: {
                id: 'id',
                status: '$publishStatus'
            }
        }
    },
    
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderAuthStatus: function(certificationStatus) {
        if (certificationStatus == -2) {
            return '1'
        }
        else if (certificationStatus == -1) {
            return '4'
        }
        else if (certificationStatus == 0) {
            return '2'
        }
        else if (certificationStatus == 1) {
            return '3'
        }
        else {
            return '1'
        }
    },
    formatStatus: function(publishStatus) {
        return (Number(publishStatus) - 2).toString()
    },
    renderStatus: function(state) {
        return (Number(state) + 1).toString()
    },
    renderPublishStatus: function(status) {
        return (status == -1) ? '1' : '2'
    }
}

module.exports = tbs_model_vo_MatchManager